export const API_ENDPOINT = "https://api.unicall.in/v1/cabinet/";
// export const API_DEV_ENDPOINT = 'http://api.phobos.unicall.in/v1/cabinet/';
export const API_DEV_ENDPOINT = "https://api.dev.unicall.in/v1/cabinet/";

export const AUTH_LOGIN = "auth/login";
export const AUTH_TOKEN = "auth/token";
export const AUTH_REGISTER = "auth/registration";
export const AUTH_LOST = "auth/lost";
export const AUTH_LOGOUT = "auth/logout";
export const AUTH_CONTACT_US = "auth/contact-us/";
export const COUNTRIES = "countries";
export const LANGUAGES = "languages";
export const LOCALES = "languages/locales";
export const SET_LOCALE = "employee/set-locale";
export const TEL_CODES = "countries/telcodes";
export const EMPLOYEE = "employee";
export const EMPLOYEE_UPDATE = "employee/update";
export const GET_TEST = "education/get-test";
export const SAVE_TEST = "education/save-test";
export const GET_CATEGORIES = "education/get-categories";
export const GET_CATEGORY = "education/get-category/";
export const GET_GOOD_CALLS = "education/get-good-calls";
export const GET_ATTESTATIONS = "attestation/get-attestations";
export const GET_ATTESTATION_BY_ID = "attestation/get-attestation";
export const GET_ATTESTATION_TEST_BY_ID = "attestation/get-test-by-id";
export const GET_ATTESTATION_BLOCK = "attestation/get-test-block";
export const SAVE_ATTESTATION_TEST = "attestation/save-test-answers";
export const GET_COURSE = "education/get-course/";
export const GET_EXAM = "education/get-examine/";
export const SAVE_EXAM = "education/save-examine";
export const BEGIN_EDUCATION = "education/begin-education/";
export const GET_PHRASES = "languages/get-phrases/";
export const GET_TIME = "auth/get-time";
export const CHANGE_READY = "auth/change-ready";
export const GET_KEEP_ALIVE = "auth/keep-alive";
export const GET_ORDER = "order/get-order";
export const GET_SIMILAR_ORDERS = "order/similar-orders";
export const CREATE_REQUEST = "order/create-request";
export const GET_ORDER_PRODUCTS = "order/get-order-products";
export const SAVE_ORDER = "order/save";
export const CHANGE_ORDER_COUNTRY = "order/change-order-country";
export const GET_TIMEZONES = "auth/get-timezones";
export const SET_TIMEZONE = "auth/set-timezone";
export const SAVE_ORDER_CALL_LOG = "phone/save-order-call-log";
export const COMPLETE_ORDER_CALL = "phone/complete-call";
export const GET_TICKETS = "ticket/get-list";
export const GET_TICKET_CATEGORIES = "ticket/get-categories";
export const SAVE_TICKET = "ticket/save";
export const SAVE_DELIVERY_CONSULTATION_TICKET = "ticket/save-delivery-consultation";
export const GET_TICKET_BY_ID = "ticket/get";
export const SET_TICKET_STATUS = "ticket/set-status";
export const ADD_MESSAGE = "ticket/add-message";
export const GET_RATING = "employee/get-rating";
export const GET_NOTIFICATIONS = "notification/get-list";
export const DELETE_NOTIFICATION = "notification/delete";
export const DELETE_ALL_NOTIFICATIONS = "notification/delete-all";
export const GET_RECALLS = "order/get-recalls";
export const IFRAME_GET_URL = "iframe/get-url";
export const IFRAME = "iframe";
export const GET_COMMON_INFO = "employee/get-common-info";
export const IFRAME_GET_COMMON_INFO = "iframe/get-common-info";
export const ORDER_SEND_INFO = "order/send-info";
export const GET_CREATE_DATA = "order/get-create-data";
export const CREATE_ORDER = "order/create-order";
export const GET_AUDIT_INFO = "order/get-audit-info";
export const GET_SCRIPT = "script/get-script";
export const GET_SCRIPTS_BY_COUNTRY = "script/get-scripts-by-country";
export const GET_PHONE_DATA = "order/get-phone-data";
export const GET_DELIVERY_ORDER = "order/get-delivery-logistic-order";
export const GET_ORDER_RECORDS = "order/get-records-data";
export const GET_PASSWORD = "auth/get-password";
export const GET_CALLING_LIST = "employee/get-calling-list";
export const SAVE_OPERATOR_ORDER_NOTE = "employee/save-operator-order-note";
export const AUTH_SET_EMAIL = "auth/set-email";
export const RESEND_PAYMENT_LINK = "order/resend-payment-link";
export const GET_PAYMENT_LINKS_LIFETIME = "employee/check-payment-links-lifetime";
export const SEND_INCOME_CALL_NUMBER = "order/incoming-call-user";
